import FormularioRecibos from '../../components/recibos/FormularioRecibos';

const ListadoRecibos = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Recibos</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Gestiona y busca recibos del sistema
      </p>
    </div>
    <FormularioRecibos />
  </div>
);

export default ListadoRecibos;
